export default __webpack_public_path__ + "static/media/time-fill.feab28e9.svg";